<template>
    <v-container fluid class="px-4" v-if="event">
        <div class="pa-4 grey lighten-3">
            <div class="headline">{{ event.customer }}</div>
            <div class="font-weight-bold mt-1">{{ `Team building - ${$util.getDDMMYYYYDateFormat(event.startDate)}` }}</div>
            <div class="subtitle-1">{{ $t('eventList.participantDetails', { amount: event.participantAmount, team: event.teamAmount }) }}</div>
        </div>

        <div class="qr-container d-flex flex-column align-center pa-4 mt-4">
            <div class="font-weight-bold title">{{ event.customer }}</div>
            <img
                :src="qrCodeURL"
                :style="{
                    width: '350px',
                    height: '350px'
                }"/>
            <div>AM: <b>XXXXX</b></div>
        </div>

        <div
            class="qr-container pa-2 clickable mt-4 d-flex justify-center"
            @click="downloadQrCode">
            <icon
                class="mr-2"
                value="hero_Printer"/>
            <div>Print QR Code</div>
        </div>
    </v-container>
    <div v-else/>
</template>

<script>
import { jsPDF as JSPDF } from 'jspdf'
import andamandaLogoImage from '../assets/logo-andamanda.png'

const QRCode = require('qrcode')

export default {
    name: 'EventQRView',

    props: {
        event: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            qrCodeURL: ''
        }
    },

    watch: {
        event: {
            async handler () {
                this.qrCodeURL = await QRCode.toDataURL(
                    'https://andamanda-bof-dev.pirsquare.net/',
                    { errorCorrectionLevel: 'H' })
            },

            deep: true
        }
    },

    methods: {
        async downloadQrCode () {
            const doc = new JSPDF()
            const pageWidth = doc.internal.pageSize.getWidth()

            doc.addImage(andamandaLogoImage, 'PNG', (pageWidth - 86.4) / 2, 10, 86.4, 25)
            doc.text('SCAN TO JOIN TEAM', (pageWidth - doc.getTextWidth('SCAN TO JOIN TEAM')) / 2, 30)
            doc.text(this.event.customer, (pageWidth - doc.getTextWidth(this.event.customer)) / 2, 40)
            doc.addImage(this.qrCodeURL, 'JPEG', (pageWidth - 64) / 2, 50, 64, 64)
            doc.text('AM: ', (pageWidth - doc.getTextWidth('AM: ')) / 2, 70)
            doc.text('XXXX', (pageWidth - doc.getTextWidth('XXXX')) / 2, 70)
            doc.text(`${this.event.customer} Team Building`, (pageWidth - doc.getTextWidth(`${this.event.customer} Team Building`)) / 2, 80)
            doc.text(`${this.$util.getDDMMYYYYDateFormat(this.event.startDate)}`, (pageWidth - doc.getTextWidth(`${this.$util.getDDMMYYYYDateFormat(this.event.startDate)}`)) / 2, 100)

            const file = new Blob([doc.output('blob')], {
                type: 'application/pdf;charset=utf-8'
            })

            const fileURL = URL.createObjectURL(file)

            if (fileURL) {
                const pdfWindow = window.open()
                pdfWindow.location.href = fileURL
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.qr-container {
    border: 1px solid #d5d5d5;
}
</style>
